import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-footer-payment-system',
  templateUrl: './footer-payment-system.component.html',
  styleUrls: ['./footer-payment-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterPaymentSystemComponent {}
